// src/components/CollapsibleFilterBar.jsx
import React, { useState } from 'react';
import {
  Box,
  Button,
  Chip,
  Collapse,
  alpha,
  useTheme
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FilterBar from './FilterBar';

const CollapsibleFilterBar = ({
  modifiedDate,
  onModifiedDateChange,
  types,
  selTypes,
  onSelTypesChange,
  owners,
  selOwners,
  onSelOwnersChange,
  dealName,
  onDealNameChange,
  adcoOnly = false,
  onAdcoOnlyChange,
  isDealLoaded = false
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(true);
  
  // Auto-collapse when deal is loaded
  React.useEffect(() => {
    if (isDealLoaded) {
      setExpanded(false);
    }
  }, [isDealLoaded]);
  
  const activeFilterCount = selTypes.length
    + selOwners.length
    + (dealName ? 1 : 0)
    + (adcoOnly ? 1 : 0);

  return (
    <Box>
      <Button
        fullWidth
        onClick={() => setExpanded(!expanded)}
        startIcon={<FilterListIcon />}
        endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{
          justifyContent: 'space-between',
          textTransform: 'none',
          py: 1.5,
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          color: theme.palette.primary.main,
          fontWeight: 600,
          mb: expanded ? 2 : 1,
          '&:hover': {
            bgcolor: alpha(theme.palette.primary.main, 0.2)
          }
        }}
      >
        {expanded ? 'Hide Filters' : 'Show Filters'}
        {activeFilterCount > 0 && (
          <Chip
            label={`${activeFilterCount} active`}
            size="small"
            sx={{
              ml: 1,
              height: 20,
              fontSize: '11px',
              bgcolor: theme.palette.primary.main,
              color: 'white'
            }}
          />
        )}
      </Button>
      <Collapse in={expanded}>
        <FilterBar
          modifiedDate={modifiedDate}
          onModifiedDateChange={onModifiedDateChange}
          types={types}
          selTypes={selTypes}
          onSelTypesChange={onSelTypesChange}
          owners={owners}
          selOwners={selOwners}
          onSelOwnersChange={onSelOwnersChange}
          dealName={dealName}
          onDealNameChange={onDealNameChange}
          adcoOnly={adcoOnly}
          onAdcoOnlyChange={onAdcoOnlyChange}
        />
      </Collapse>
    </Box>
  );
};

export default CollapsibleFilterBar;
